import React from "react";
import { Link } from "react-router-dom";

const Fun = () => {
  return (
    <div className="each-container">
      <div className="awards-part">
        <div id="news">
          <div className="title">Fun</div>
          In spare time, I enjoy{" "}
          <span className="tooltip">
            traveling
            <span className="top">
              🇨🇳🇺🇸🇬🇧🇹🇭🇯🇵🇰🇷🇩🇪🇫🇷🇧🇪🇫🇮🇸🇪🇩🇰🇸🇬🇮🇩🇭🇰🇲🇴🇪🇬
              <i></i>
            </span>
          </span>
          , playing{" "}
          <span className="tooltip">
            instruments{" "}
            <span className="top">
              piano, erhu, guitar, ukulele, electronic keyboard
              <i></i>
            </span>
          </span>
          , and trying new  <span className="tooltip">foods<span className="top">
              ☕️🥟🍣🍛🍝🍰 and more...
              <i></i>
            </span></span>!
        </div>
      </div>
    </div>
  );
};

export default Fun;
